<template>
  <div class="product-details">
    <v-card v-if="gettingData" class="common-card-log">
      <div class="d-flex flex-column align-items-center mt-8 py-6">
        <looping-rhombuses-spinner
          :animation-duration="2500"
          :rhombus-size="15"
          color="#a076f9"
          class="mx-auto my-10"
        />
      </div>
    </v-card>
    <div v-else>
      <v-card class="common-card-log">
        <div class="details_product_info">
          <DivisionInfo :division-details="divisionDetails" />
        </div>
      </v-card>
      <v-divider></v-divider>
      <v-card class="common-card-log">
        <div v-if="pageLoading" class="text-center">
          <looping-rhombuses-spinner
            :animation-duration="2500"
            :rhombus-size="15"
            color="#6200ea"
            class="mx-auto my-10"
          />
        </div>

        <div v-else-if="divisionBooks.length > 0" class="d-flex flex-column">
          <div class="card_store">
            <v-row>
              <v-col
                v-for="(item, index) in divisionBooks"
                :key="index"
                xl="3"
                lg="3"
                md="6"
                sm="6"
                xs="12"
                cols="12"
                align="center"
              >
                <DivisionItem :item="item" :cart-id="cartId" />
              </v-col>
            </v-row>
          </div>
          <div class="mt-6 d-none d-md-block">
            <v-pagination
              v-model="currentPage"
              :length="totalPages"
              :total-visible="5"
              circle
              color="shopPrimary"
              prev-icon="$ArrowLeft"
              next-icon="$ArrowRight"
              @input="next()"
            ></v-pagination>
          </div>
          <div class="mt-6 d-block d-md-none">
            <v-pagination
              v-model="currentPage"
              :length="totalPages"
              :total-visible="4"
              circle
              color="shopPrimary"
              prev-icon="$ArrowLeft"
              next-icon="$ArrowRight"
              @input="next()"
            ></v-pagination>
          </div>
        </div>
      </v-card>
      <v-divider v-if="divisionDetails.description"></v-divider>
      <v-card class="common-card-log" v-if="divisionDetails.description">
        <div class="details_product_info">
          <DivisionDescription :division-details="divisionDetails" />
        </div>
      </v-card>
    </div>

    <v-dialog v-model="loginDialog" width="450">
      <Login @closeLogin="closeLogin" />
    </v-dialog>
  </div>
</template>

<script>
import { HalfCircleSpinner, LoopingRhombusesSpinner } from "epic-spinners";
import Axios from "axios";
import Login from "../../../components/OnlineShop/Login";
import { mapGetters, mapMutations } from "vuex";
import { EventBus } from "../../../event-bus";
import DivisionInfo from "@/views/OnlineShop/Division/Components/DivisionInfo";
import DivisionDescription from "@/views/OnlineShop/Division/Components/DivisionDescription";
import DivisionItem from "@/views/OnlineShop/Division/Components/DivisionItem";

export default {
  components: {
    DivisionInfo,
    DivisionItem,
    DivisionDescription,
    HalfCircleSpinner,
    LoopingRhombusesSpinner,
    Login,
  },
  data() {
    return {
      pageLoading: false,
      divisionDetails: {},
      divisionBooks: [],
      publishers: [],
      cart: [],
      productCount: 1,
      changeCountLoading: false,
      isLoading: false,
      gettingData: false,
      isUserLogin: false,
      loginDialog: false,
      reactivity: false,
      currentPage: 1,
      totalPages: 0,
      cartId: "",
    };
  },
  metaInfo() {
    return {
      title: `${
        this.divisionDetails.name
          ? `سری ${this.divisionDetails.name} | کتاب باز`
          : "کتاب باز"
      }`,
      // Meta title
      meta: [
        {
          name: "description",
          content: this.divisionDetails.description, // Meta description
        },
        {
          property: "og:title", // Open Graph meta tag
          content: this.divisionDetails.name,
        },
        {
          property: "og:description",
          content: this.divisionDetails.description,
        },
        {
          property: "og:image",
          content: this.divisionDetails.publisherLogo,
        },
      ],
      script: [
        {
          type: "application/ld+json",
          json: {
            "@context": "https://schema.org",
            "@type": "Organization",
            name: this.divisionDetails.name,
            description: this.divisionDetails.description,
            image: this.divisionDetails.pictureUrl,
            url: this.divisionDetails.name
              ? this.createSchemaTRL(
                  "division",
                  this.divisionDetails.name,
                  this.mainId
                )
              : undefined,
          },
        },
      ],
    };
  },
  beforeDestroy() {
    // Reset the meta title when leaving the page
    document.title = "کتاب باز"; // Replace with your default title
    // Optionally, remove any other meta tags
    const metaTags = document.querySelectorAll(
      "meta[data-vue-router-controlled]"
    );
    metaTags.forEach((tag) => tag.parentNode.removeChild(tag));
  },
  computed: {
    ...mapGetters(["cartItems"]),
  },
  watch: {
    cartItems(val) {
      this.cart = val;
      let index = this.cart
        ? this.cart.findIndex((x) => x.id == this.mainId)
        : [];
      this.productCount = this.cart[index] ? this.cart[index].amount : 0;
    },
  },
  methods: {
    ...mapMutations(["setInCart"]),
    createSchemaTRL(type, name, id) {
      return `https://ketabbaaz.com/${type}/${name.replaceAll(" ", "-")}-${id}`;
    },
    goToProductDetails(item) {
      this.$router.push(item.id);
      EventBus.$emit("updateProductDetails");
    },
    closeLogin() {
      this.loginDialog = false;
      location.reload();
    },
    next() {
      this.getDivisionInfo();
    },
    getDivisionInfo() {
      this.gettingData = true;
      Axios.get(
        `${this.baseUrl}/onlineShop/division/getData/${this.mainId}?page=${this.currentPage}`,
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("shopToken"),
          },
        }
      )
        .then((res) => {
          if (res.status == 200) {
            this.divisionDetails = res.data.data;
            // this.$router.replace({
            //   path: `/division/${this.divisionDetails.name.replaceAll(
            //     " ",
            //     "-"
            //   )}-${this.mainId}`,
            // });
            this.divisionBooks = res.data.books;
            this.currentPage = res.data.divisionBooksPageNumber;
            this.totalPages = res.data.divisionBooksTotalPages;
            this.reactivity = !this.reactivity;
            this.gettingData = false;
            let container = document.getElementsByTagName("html")[0];
            container.scrollIntoView({ block: "start", behavior: "smooth" });
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
            this.gettingData = false;
          }
        })
        .catch((err) => {
          this.toast(err.response.data, "error");
          this.gettingData = false;
        });
    },
  },
  mounted() {
    this.mainId = this.$route.params.id.split("-").pop();
    this.cartId = localStorage.getItem("cartId");
    this.$store.dispatch("getCartData", {
      cartId: this.cartId,
    });
    EventBus.$on("updateProductDetails", () => {
      this.getDivisionInfo();
    }),
      // this.getShippingCost();
      window.localStorage.getItem("shopToken")
        ? (this.isUserLogin = true)
        : (this.isUserLogin = false);
    this.getDivisionInfo();
    this.cart = localStorage.getItem("cart")
      ? JSON.parse(localStorage.getItem("cart"))
      : [];
  },
};
</script>

<style lang="scss">
.details_product_info {
  display: flex;
  flex-wrap: wrap;
  @media only screen and (max-width: 375px) {
    flex-direction: column;
  }
}
.product-details {
  overflow: hidden;

  .price-div {
    border-radius: 10px;
    background-color: #eeeeee;
  }

  .bag-icon {
    path {
      stroke: #fff;
    }
  }

  .counterWares {
    border: 1px solid #e0e0e6;
    border-radius: 10px;
    margin-top: -3px;
    width: 110px;
    height: 42px;
  }

  .star-icon {
    width: 35px;
    height: 35px;
  }

  .extra-images {
    width: 90px;
    height: 90px;
    background-size: cover;
  }

  .question-icon {
    path {
      stroke: #1a237e;
    }
  }

  .tags {
    height: auto !important;
    min-height: 100px !important;
  }
}

.products {
  &.special-products {
    overflow-x: auto;
    overflow-y: hidden;
    scroll-behavior: smooth;

    .product-item {
      max-width: none;
    }

    &::-webkit-scrollbar {
      display: none;
    }
  }

  .product-item {
    width: 100%;
    max-width: 240px;
    height: 380px;
    background-color: #fff;
    border-radius: 12px;

    .product-image {
      position: relative;

      img {
        width: 100%;
        border-radius: 12px 12px 0 0;
        aspect-ratio: 1 / 1;
      }

      .operation {
        position: absolute;
        bottom: 5px;
        right: 100px;
      }

      .add-btn {
        min-width: 0 !important;
        width: 35px;

        .v-icon {
          font-size: 1.2rem;
        }
      }
    }
  }
}

.online-table {
  .headClass {
    background-color: #ffffff;

    th {
      border: none !important;
      font-weight: normal !important;

      div {
        color: #4e536a;
      }
    }
  }

  .trClass {
    tr {
      background-color: #ffffff !important;
    }
  }

  .bodyClass {
    tr {
      border: none !important;
      height: 68px !important;

      background-color: #ffffff !important;

      td {
        border: none !important;
        text-align: center !important;
        background-color: #ffffff !important;

        div {
          padding-top: 5px;
        }

        &:nth-child(1) {
          border-top-right-radius: 8px !important;
          border-bottom-right-radius: 8px !important;
          background-color: #ffffff !important;
        }

        &:last-child {
          border-top-left-radius: 8px !important;
          border-bottom-left-radius: 8px !important;
          background-color: #ffffff !important;
        }
      }
    }
  }

  .v-pagination {
    .v-pagination__item.v-pagination__item--active {
      background-color: #f4f4ff !important;
      border: 1px solid #ef6c00 !important;
      font-size: 0.8rem !important;
      color: #ef6c00 !important;
      border-radius: 9px !important;
    }

    .v-pagination__item {
      border: none !important;
      box-shadow: none !important;
      background-color: transparent !important;
      font-size: 0.85rem !important;
      outline: none !important;
      color: #ef6c00 !important;
      font-weight: bold !important;
    }

    .v-pagination__navigation {
      border: 1px solid #ef6c00 !important;
      box-shadow: none !important;
      background-color: transparent !important;
      font-size: 12px !important;
      border-radius: 9px !important;

      path {
        stroke: #ef6c00;
      }
    }
  }

  .inner-pagination {
    svg {
      transform: translateY(-10px);
    }
  }

  .navigation-btn {
    border-radius: 9px !important;
    border: 1px solid #ef6c00 !important;
    box-shadow: none !important;
    background-color: transparent !important;
    font-size: 12px !important;
    height: 32px !important;
    width: 32px !important;
    min-width: 32px !important;
    padding: 0 !important;
    margin-top: 0.36rem;

    path {
      stroke: #ef6c00;
    }
  }

  .number-box {
    .v-text-field.v-text-field--enclosed .v-text-field__details,
    .v-text-field.v-text-field--enclosed:not(.v-text-field--rounded)
      > .v-input__control
      > .v-input__slot {
      width: 70px !important;
      height: 34px !important;
      min-height: 34px !important;
      padding: 0 5px !important;

      .v-icon {
        transform: translateY(-12px);
        color: #ef6c00;
      }

      .v-select__selection--comma {
        color: #ef6c00;
      }
    }

    .v-list-item__content {
      padding: 0 !important;
    }

    .v-list-item {
      min-height: 40px !important;
    }

    .v-text-field .v-input__control,
    .v-text-field fieldset {
      border-radius: 8px !important;
      border-color: #ef6c00 !important;
    }

    .v-text-field__details {
      display: none !important;
    }

    input {
      text-align: center;
      color: #ef6c00 !important;
    }
  }
}

table {
  border-radius: 10px;
  overflow: hidden;
}

tbody tr:nth-child(even) {
  background-color: #ffffff !important;
}

table thead {
  background-color: white;
  color: black;
}

.logoPic {
  position: center !important;
  background-size: cover !important;

  img {
    height: 80px !important;
    width: auto !important;
    //  max-width:100px !important;
  }

  //  margin:0;
}

.color {
  width: 25px;
  height: 25px;
  border-radius: 50px;
}
.line-subject-comment {
  border-bottom: 1px dashed #a076f9;
}
</style>
